module.exports = __webpack_public_path__ + "static/media/selecteur1.97fb965e.svg";